import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@montugroup/design-system';
import WarningIcon from '@mui/icons-material/Warning';
import { useTheme } from '@mui/material';

export function ClickAndCollectAcknowledgePartialInventoryModal({
  open,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  const theme = useTheme();

  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>
        <WarningIcon sx={{ color: theme.palette.warning.main }} />
        Pharmacy awaiting stock
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Your order will be ready in an estimated <b>3–7 business days.</b> We&apos;ll notify you by SMS/email when
          it&apos;s ready to collect.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onCancel}>
          Reselect location
        </Button>
        <Button variant="contained" onClick={onConfirm}>
          Okay, I understand
        </Button>
      </DialogActions>
    </Dialog>
  );
}
